module.exports = __webpack_public_path__ + "media/images/placeholder-author-a8b3f0baf455e05236aa1530fb26a719.jpg";